export default __webpack_public_path__ + "static/media/G0535.34I-29290_-16971_0.1654019700000.8a7488a4.jpg";